import { put } from 'redux-saga/effects';

import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';
import {
  PURCHASE_INITIAL_CHECKOUT,
  PRODUCT_CHECKOUT,
  PRODUCT_PURCHASE,
  PURCHASE_SUCCESS,
  PURCHASE_SUCCESS_COURSE,
  PURCHASE_SUCCESS_REGULAR_CLASS,
  PURCHASE_SUCCESS_GROUP_PASS,
} from '@dragonfruit/constants/gtmEvents';
import {
  COURSE_TYPES,
  REGULAR_CLASS_TYPES,
  GROUP_PASS_TYPES,
} from '@dragonfruit/constants/sellingTypes';
import { WEB } from '@dragonfruit/constants/platformTypes';

const getPurchaseEventName = sellingTypes => {
  if (sellingTypes) {
    if (sellingTypes.some(type => REGULAR_CLASS_TYPES.includes(type))) {
      return PURCHASE_SUCCESS_REGULAR_CLASS;
    }

    if (sellingTypes.some(type => GROUP_PASS_TYPES.includes(type))) {
      return PURCHASE_SUCCESS_GROUP_PASS;
    }

    if (sellingTypes.some(type => COURSE_TYPES.includes(type))) {
      return PURCHASE_SUCCESS_COURSE;
    }
  }

  return PURCHASE_SUCCESS;
};

export function* sendInitialCheckoutEvents({
  sku,
  name,
  price,
  planId,
  planType,
  currency,
  paymentType,
  discountCode,
  sellingTypes,
  questionQuota,
  paymentMethodId,
}) {
  let products = [
    {
      id: sku,
      name: name,
      category: planType,
      price: price,
      quantity: 1,
    },
  ];

  if (discountCode) {
    products[0].coupon = discountCode;
  }

  yield put(
    sendGtmEvent({
      eventName: PRODUCT_CHECKOUT,
      data: {
        ecommerce: {
          currencyCode: currency,
          checkout: {
            products,
          },
        },
      },
    })
  );

  yield put(
    sendGtmEvent({
      eventName: PURCHASE_INITIAL_CHECKOUT,
      data: {
        content_ids: [paymentMethodId],
        content_type: sellingTypes.join('-'),
        contents: sku,
        num_items: questionQuota,
        paymentType: paymentType,
        platform: WEB,
        value: price,
        planId,
        currency,
      },
    })
  );
}

export function* sendSuccessCheckoutEvents({
  sku,
  name,
  price,
  planId,
  currency,
  planType,
  orderNumber,
  originPrice,
  sellingTypes,
  discountCode,
  questionQuota,
}) {
  yield put(
    sendGtmEvent({
      eventName: PRODUCT_PURCHASE,
      data: {
        ecommerce: {
          currencyCode: currency,
          purchase: {
            actionField: {
              id: orderNumber,
              revenue: price,
            },
            products: [
              {
                id: sku,
                quantity: 1,
                category: planType,
                price: originPrice,
                coupon: discountCode,
                name,
              },
            ],
          },
        },
      },
    })
  );

  yield put(
    sendGtmEvent({
      eventName: getPurchaseEventName(sellingTypes),
      data: {
        value: price,
        contents: sku,
        content_name: name,
        content_type: planType,
        content_ids: [planId],
        num_items: questionQuota,
        planId,
        currency,
      },
    })
  );
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/purchaseEvents.js